import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import BillingAccountFormPaymentStep from './BillingAccountFormPaymentStep'

const stateToProps = (state, { form }) => {
  const selector = formValueSelector(form)
  const directDebitMethod = selector(state, 'directDebitMethod')

  return {
    directDebitMethod,
  }
}

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(BillingAccountFormPaymentStep)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAccountFormPaymentStep/BillingAccountFormPaymentStep.container.js